import { convertColorStringToHex } from 'color-utils';
import { getAttributeData } from './brandingUtil';
// import { getAttributeData } from './brandingUtil';

// Constants
import BRANDING_KEYS from '../constants/brandingKeysConst';

export const getColorCSSVar = (attributes = [], CONST, CSS_VAR) => {
    const variable = {};

    // Get Value
    const { value } = getAttributeData(attributes, BRANDING_KEYS[CONST]);

    if (value) {
        const valueHex = convertColorStringToHex(value);
        // Set Variable
        variable[CSS_VAR] = valueHex;
    }

    return variable;
};

export const getImgCSSVar = (attributes = [], CONST, CSS_VAR) => {
    const variable = {};

    // Get Value
    const { value } = getAttributeData(attributes, BRANDING_KEYS[CONST]);

    if (value) {
        // Set Variable
        variable[CSS_VAR] = `url('${value}')`;
    }

    return variable;
};

export const getCSSVar = (attributes = [], CONST, CSS_VAR) => {
    const variable = {};

    // Get Value
    const { value } = getAttributeData(attributes, BRANDING_KEYS[CONST]);

    if (value) {
        // Set Variable
        variable[CSS_VAR] = value;
    }

    return variable;
};
